module.exports = __webpack_public_path__ + "img/product.e8a79777.png";